const LIST_DIVISI = [
  "Asisten Manajer Pendidikan",
  "Fasilitas Umum",
  "Hubungan Masyarakat",
  "ITF",
  "Keamanan",
  "Kemahasiswaan",
  "Keuangan",
  "Manajer Keuangan",
  "Manajer Pengadaan, Pengelolaan dan Pemeliharaan Fasilitas",
  "Manajer Sumber Daya Manusia",
  "Pemeliharaan Fasilitas",
  "Perpustakaan",
  "Riset dan Pengabdian Kepada Masyarakat",
  "Sekretariat Akademik",
  "Sekretariat Pimpinan",
  "Sumber Daya Manusia",
];

export default LIST_DIVISI;
